/**
 * @owner @Appboy/messaging-experience
 */
import { territoryRemoteLookupValidators } from "../.generated/territoryRemoteLookup";
import type { TerritoryRemoteLookupProvider } from "../.generated/territoryRemoteLookup";

export const territoryProvider: TerritoryRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: territoryRemoteLookupValidators,
};
